module.exports = __webpack_public_path__ + "asset/img/icon-alipay.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/icon-alipay.svg
// module id = 1830
// module chunks = 41